import Layout from "../../../components/layout/layout.js";
import MicroActivityLog from "../../../components/dashboard/microActivityLog";
import { useAuth } from "../../../Context/AuthContext";
import { Redirect } from "react-router-dom";

function MicroActivityLogPage({ component, ...rest }) {
  const { isSuperAdmin } = useAuth();

  if (!isSuperAdmin()) {
    return <Redirect to="/" />;
  }

  return <Layout Component={MicroActivityLog} controlsDisabled={true} {...rest} />;
}

export default MicroActivityLogPage;
